"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _TextLearning = _interopRequireWildcard(require("./learning/TextLearning"));
var _Cluster = _interopRequireWildcard(require("./learning/Cluster"));
var _Regression = _interopRequireWildcard(require("./learning/Regression"));
var _ImageLearning = _interopRequireWildcard(require("./learning/ImageLearning"));
var _SpeechClassification = _interopRequireWildcard(require("./learning/SpeechClassification"));
var _NumberClassification = _interopRequireWildcard(require("./learning/NumberClassification"));
var _DecisionTree = _interopRequireWildcard(require("./learning/DecisionTree"));
var _LogisticRegression = _interopRequireWildcard(require("./learning/LogisticRegression"));
var _Svm = _interopRequireWildcard(require("./learning/Svm"));
var _DataTable = _interopRequireDefault(require("./DataTable"));
var _block_ai_learning = _interopRequireDefault(require("../playground/blocks/block_ai_learning"));
var _block_ai_learning_knn = _interopRequireDefault(require("../playground/blocks/block_ai_learning_knn"));
var _block_ai_learning_cluster = _interopRequireDefault(require("../playground/blocks/block_ai_learning_cluster"));
var _block_ai_learning_regression = _interopRequireDefault(require("../playground/blocks/block_ai_learning_regression"));
var _block_ai_learning_logistic_regression = _interopRequireDefault(require("../playground/blocks/block_ai_learning_logistic_regression"));
var _block_ai_learning_decisiontree = _interopRequireDefault(require("../playground/blocks/block_ai_learning_decisiontree"));
var _block_ai_learning_svm = _interopRequireDefault(require("../playground/blocks/block_ai_learning_svm"));
var _block_ai_utilize_media_pipe = _interopRequireDefault(require("../playground/blocks/block_ai_utilize_media_pipe"));
var _InputPopup = _interopRequireDefault(require("./learning/InputPopup"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); } // eslint-disable-next-line max-len
Entry.MlPopup = _InputPopup["default"];
var basicBlockList = [_block_ai_learning["default"], _block_ai_learning_knn["default"], _block_ai_learning_cluster["default"], _block_ai_learning_regression["default"], _block_ai_learning_logistic_regression["default"], _block_ai_learning_decisiontree["default"], _block_ai_learning_svm["default"], _block_ai_utilize_media_pipe["default"]];
var banClasses = [].concat((0, _toConsumableArray2["default"])(_Cluster.classes), (0, _toConsumableArray2["default"])(_Regression.classes), (0, _toConsumableArray2["default"])(_TextLearning.classes), (0, _toConsumableArray2["default"])(_ImageLearning.classes), (0, _toConsumableArray2["default"])(_SpeechClassification.classes), (0, _toConsumableArray2["default"])(_NumberClassification.classes), (0, _toConsumableArray2["default"])(_DecisionTree.classes), (0, _toConsumableArray2["default"])(_LogisticRegression.classes), (0, _toConsumableArray2["default"])(_Svm.classes));
var _playground = /*#__PURE__*/new WeakMap();
var _categoryName = /*#__PURE__*/new WeakMap();
var _labels = /*#__PURE__*/new WeakMap();
var _url = /*#__PURE__*/new WeakMap();
var _type = /*#__PURE__*/new WeakMap();
var _oid = /*#__PURE__*/new WeakMap();
var _modelId = /*#__PURE__*/new WeakMap();
var _recordTime = /*#__PURE__*/new WeakMap();
var _module = /*#__PURE__*/new WeakMap();
var _tableData = /*#__PURE__*/new WeakMap();
var _dataApi = /*#__PURE__*/new WeakMap();
var AILearning = exports["default"] = /*#__PURE__*/function () {
  function AILearning(playground) {
    var isEnable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    (0, _classCallCheck2["default"])(this, AILearning);
    _classPrivateFieldInitSpec(this, _playground, void 0);
    _classPrivateFieldInitSpec(this, _categoryName, 'ai_learning');
    _classPrivateFieldInitSpec(this, _labels, []);
    _classPrivateFieldInitSpec(this, _url, void 0);
    _classPrivateFieldInitSpec(this, _type, void 0);
    _classPrivateFieldInitSpec(this, _oid, void 0);
    _classPrivateFieldInitSpec(this, _modelId, void 0);
    (0, _defineProperty2["default"])(this, "isLoaded", false);
    (0, _defineProperty2["default"])(this, "isLoading", false);
    (0, _defineProperty2["default"])(this, "result", []);
    (0, _defineProperty2["default"])(this, "isEnable", void 0);
    _classPrivateFieldInitSpec(this, _recordTime, 2000);
    _classPrivateFieldInitSpec(this, _module, null);
    _classPrivateFieldInitSpec(this, _tableData, null);
    _classPrivateFieldInitSpec(this, _dataApi, undefined);
    _classPrivateFieldSet(_playground, this, playground);
    this.isEnable = isEnable;
  }
  return (0, _createClass2["default"])(AILearning, [{
    key: "labels",
    get: function get() {
      return _classPrivateFieldGet(_labels, this);
    }
  }, {
    key: "init",
    value: function init() {
      var blockObject = {};
      basicBlockList.forEach(function (value) {
        if ('getBlocks' in value) {
          (0, _extends2["default"])(blockObject, value.getBlocks());
        }
      });
      Entry.block = (0, _extends2["default"])(Entry.block, blockObject);
    }
  }, {
    key: "setDataApi",
    value: function setDataApi(api) {
      _classPrivateFieldSet(_dataApi, this, api);
    }
  }, {
    key: "removeAllBlocks",
    value: function removeAllBlocks() {
      var utilizeBlock = [];
      Object.values(Entry.ALL_AI_UTILIZE_BLOCK_LIST).map(function (x) {
        return Object.keys(x.getBlocks());
      }).forEach(function (category) {
        category.forEach(function (block) {
          utilizeBlock.push(block);
        });
      });
      var _EntryStatic$getAllBl = EntryStatic.getAllBlocks().find(function (_ref) {
          var category = _ref.category;
          return category === 'ai_utilize';
        }),
        blocks = _EntryStatic$getAllBl.blocks;
      blocks.filter(function (x) {
        return !utilizeBlock.includes(x);
      }).forEach(function (blockType) {
        Entry.Utils.removeBlockByType(blockType);
      });
      this.banBlocks();
      this.destroy();
    }
  }, {
    key: "removeLearningBlocks",
    value: function removeLearningBlocks() {
      if (!this.isLoaded) {
        return;
      }
      _classPrivateFieldSet(_modelId, this, undefined);
      var _EntryStatic$getAllBl2 = EntryStatic.getAllBlocks().find(function (_ref2) {
          var category = _ref2.category;
          return category === 'ai_utilize';
        }),
        blocks = _EntryStatic$getAllBl2.blocks;
      blocks.filter(function (x) {
        var _Entry$block;
        return ((_Entry$block = Entry.block) === null || _Entry$block === void 0 || (_Entry$block = _Entry$block[x]) === null || _Entry$block === void 0 ? void 0 : _Entry$block["class"]) === 'ai_learning';
      }).forEach(function (blockType) {
        Entry.Utils.removeBlockByType(blockType);
      });
      this.banBlocks();
      this.destroy();
    }
  }, {
    key: "loadModel",
    value: function () {
      var _loadModel = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref3) {
        var _classPrivateFieldGet2;
        var url, trainParam, tableData, isActive, classes, modelPath, type, name, recordTime, _classPrivateFieldGet3, _classPrivateFieldGet4, _classPrivateFieldGet5, _classPrivateFieldGet6;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = _ref3.url, trainParam = _ref3.trainParam, tableData = _ref3.tableData, isActive = _ref3.isActive, classes = _ref3.classes;
              _context.next = 1;
              return (_classPrivateFieldGet2 = _classPrivateFieldGet(_dataApi, this)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.getModelDownloadUrl(url);
            case 1:
              modelPath = _context.sent;
              if (!(!modelPath || !this.isEnable || !isActive)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              type = _classPrivateFieldGet(_type, this);
              name = this.name;
              recordTime = _classPrivateFieldGet(_recordTime, this);
              if (type === 'text') {
                _classPrivateFieldSet(_module, this, new _TextLearning["default"]({
                  url: modelPath,
                  labels: _classPrivateFieldGet(_labels, this),
                  type: type,
                  modelId: _classPrivateFieldGet(_modelId, this),
                  loadModel: (_classPrivateFieldGet3 = _classPrivateFieldGet(_dataApi, this)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.loadModel
                }));
              } else if (type === 'number') {
                _classPrivateFieldSet(_tableData, this, tableData || createDataTable(classes, name));
                _classPrivateFieldSet(_module, this, new _NumberClassification["default"]({
                  name: name,
                  result: this.result,
                  url: modelPath,
                  trainParam: trainParam,
                  table: _classPrivateFieldGet(_tableData, this),
                  modelId: _classPrivateFieldGet(_modelId, this),
                  loadModel: (_classPrivateFieldGet4 = _classPrivateFieldGet(_dataApi, this)) === null || _classPrivateFieldGet4 === void 0 ? void 0 : _classPrivateFieldGet4.loadModel
                }));
                _classPrivateFieldSet(_labels, this, _classPrivateFieldGet(_module, this).getLabels());
              } else if (type === 'cluster') {
                _classPrivateFieldSet(_tableData, this, tableData || createDataTable(classes, name));
                _classPrivateFieldSet(_module, this, new _Cluster["default"]({
                  name: name,
                  result: this.result,
                  trainParam: trainParam,
                  table: _classPrivateFieldGet(_tableData, this)
                }));
              } else if (type === 'regression') {
                _classPrivateFieldSet(_tableData, this, tableData || createDataTable(classes, name));
                _classPrivateFieldSet(_module, this, new _Regression["default"]({
                  name: name,
                  result: this.result,
                  url: modelPath,
                  trainParam: trainParam,
                  table: _classPrivateFieldGet(_tableData, this)
                }));
              } else if (type === 'image') {
                _classPrivateFieldSet(_module, this, new _ImageLearning["default"]({
                  url: modelPath,
                  labels: _classPrivateFieldGet(_labels, this),
                  type: type
                }));
              } else if (type === 'speech') {
                _classPrivateFieldSet(_module, this, new _SpeechClassification["default"]({
                  url: modelPath,
                  labels: _classPrivateFieldGet(_labels, this),
                  type: type,
                  recordTime: recordTime
                }));
              } else if (type === 'logisticRegression') {
                _classPrivateFieldSet(_tableData, this, tableData || createDataTable(classes, name));
                _classPrivateFieldSet(_module, this, new _LogisticRegression["default"]({
                  name: name,
                  result: this.result,
                  url: modelPath,
                  trainParam: trainParam,
                  table: _classPrivateFieldGet(_tableData, this)
                }));
              } else if (type === 'decisionTree') {
                _classPrivateFieldSet(_tableData, this, tableData || createDataTable(classes, name));
                _classPrivateFieldSet(_module, this, new _DecisionTree["default"]({
                  name: name,
                  result: this.result,
                  url: modelPath,
                  trainParam: trainParam,
                  table: _classPrivateFieldGet(_tableData, this),
                  modelId: _classPrivateFieldGet(_modelId, this),
                  loadModel: (_classPrivateFieldGet5 = _classPrivateFieldGet(_dataApi, this)) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.loadModel
                }));
              } else if (type === 'svm') {
                _classPrivateFieldSet(_tableData, this, tableData || createDataTable(classes, name));
                _classPrivateFieldSet(_module, this, new _Svm["default"]({
                  name: name,
                  result: this.result,
                  url: modelPath,
                  trainParam: trainParam,
                  table: _classPrivateFieldGet(_tableData, this),
                  modelId: _classPrivateFieldGet(_modelId, this),
                  loadModel: (_classPrivateFieldGet6 = _classPrivateFieldGet(_dataApi, this)) === null || _classPrivateFieldGet6 === void 0 ? void 0 : _classPrivateFieldGet6.loadModel
                }));
              }
              if (_classPrivateFieldGet(_module, this)) {
                this.unbanBlocks();
                this.isLoaded = true;
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadModel(_x) {
        return _loadModel.apply(this, arguments);
      }
      return loadModel;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(modelInfo) {
        var _ref4, labels, type, _ref4$classes, classes, model, id, url, _id, _ref4$isActive, isActive, name, recordTime, trainParam, tableData, result;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref4 = modelInfo || {}, labels = _ref4.labels, type = _ref4.type, _ref4$classes = _ref4.classes, classes = _ref4$classes === void 0 ? [] : _ref4$classes, model = _ref4.model, id = _ref4.id, url = _ref4.url, _id = _ref4._id, _ref4$isActive = _ref4.isActive, isActive = _ref4$isActive === void 0 ? true : _ref4$isActive, name = _ref4.name, recordTime = _ref4.recordTime, trainParam = _ref4.trainParam, tableData = _ref4.tableData, result = _ref4.result;
              if (_classPrivateFieldGet(_dataApi, this)) {
                _context2.next = 1;
                break;
              }
              console.log('there is no dataApi');
              return _context2.abrupt("return");
            case 1:
              if (!(0, _isEmpty2["default"])(modelInfo)) {
                _context2.next = 2;
                break;
              }
              console.log('empty modelInfo');
              return _context2.abrupt("return");
            case 2:
              this.destroy();
              _classPrivateFieldSet(_labels, this, labels || classes.map(function (_ref5) {
                var name = _ref5.name;
                return name;
              }));
              _classPrivateFieldSet(_type, this, type);
              _classPrivateFieldSet(_url, this, url);
              _classPrivateFieldSet(_oid, this, _id);
              this.name = name;
              _classPrivateFieldSet(_modelId, this, model || id);
              _classPrivateFieldSet(_recordTime, this, recordTime);
              this.result = result;
              if (_classPrivateFieldGet(_playground, this)) {
                _classPrivateFieldGet(_playground, this).reloadPlayground();
              }
              this.loadModel({
                url: url,
                trainParam: trainParam,
                tableData: tableData,
                isActive: isActive,
                classes: classes
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function load(_x2) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "reload",
    value: function () {
      var _reload = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(url) {
        var _classPrivateFieldGet7, _classPrivateFieldGet8;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return (_classPrivateFieldGet7 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet7 === void 0 || (_classPrivateFieldGet8 = _classPrivateFieldGet7.reload) === null || _classPrivateFieldGet8 === void 0 ? void 0 : _classPrivateFieldGet8.call(_classPrivateFieldGet7, url);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function reload(_x3) {
        return _reload.apply(this, arguments);
      }
      return reload;
    }()
  }, {
    key: "openInputPopup",
    value: function openInputPopup() {
      var _classPrivateFieldGet9, _classPrivateFieldGet0;
      (_classPrivateFieldGet9 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet9 === void 0 || (_classPrivateFieldGet0 = _classPrivateFieldGet9.openInputPopup) === null || _classPrivateFieldGet0 === void 0 || _classPrivateFieldGet0.call(_classPrivateFieldGet9);
    }
  }, {
    key: "train",
    value: function train() {
      var _classPrivateFieldGet1, _classPrivateFieldGet10;
      (_classPrivateFieldGet1 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet1 === void 0 || (_classPrivateFieldGet10 = _classPrivateFieldGet1.train) === null || _classPrivateFieldGet10 === void 0 || _classPrivateFieldGet10.call(_classPrivateFieldGet1);
    }
  }, {
    key: "isTrained",
    value: function isTrained() {
      var _classPrivateFieldGet11, _classPrivateFieldGet12;
      return (_classPrivateFieldGet11 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet11 === void 0 || (_classPrivateFieldGet12 = _classPrivateFieldGet11.isTrained) === null || _classPrivateFieldGet12 === void 0 ? void 0 : _classPrivateFieldGet12.call(_classPrivateFieldGet11);
    }
  }, {
    key: "setTrainOption",
    value: function setTrainOption(type, value) {
      var _classPrivateFieldGet13, _classPrivateFieldGet14;
      (_classPrivateFieldGet13 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet13 === void 0 || (_classPrivateFieldGet14 = _classPrivateFieldGet13.setTrainOption) === null || _classPrivateFieldGet14 === void 0 || _classPrivateFieldGet14.call(_classPrivateFieldGet13, type, value);
    }
  }, {
    key: "getTrainOption",
    value: function getTrainOption() {
      var _classPrivateFieldGet15, _classPrivateFieldGet16;
      return (_classPrivateFieldGet15 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet15 === void 0 || (_classPrivateFieldGet16 = _classPrivateFieldGet15.getTrainOption) === null || _classPrivateFieldGet16 === void 0 ? void 0 : _classPrivateFieldGet16.call(_classPrivateFieldGet15);
    }
  }, {
    key: "getTableData",
    value: function getTableData() {
      return _classPrivateFieldGet(_tableData, this);
    }
  }, {
    key: "getTrainResult",
    value: function getTrainResult() {
      var _classPrivateFieldGet17, _classPrivateFieldGet18;
      return (_classPrivateFieldGet17 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet17 === void 0 || (_classPrivateFieldGet18 = _classPrivateFieldGet17.getTrainResult) === null || _classPrivateFieldGet18 === void 0 ? void 0 : _classPrivateFieldGet18.call(_classPrivateFieldGet17);
    }
  }, {
    key: "getPredictResult",
    value: function getPredictResult(index) {
      var _classPrivateFieldGet19, _classPrivateFieldGet20;
      return (_classPrivateFieldGet19 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet19 === void 0 || (_classPrivateFieldGet20 = _classPrivateFieldGet19.getResult) === null || _classPrivateFieldGet20 === void 0 ? void 0 : _classPrivateFieldGet20.call(_classPrivateFieldGet19, index);
    }
  }, {
    key: "getId",
    value: function getId() {
      return _classPrivateFieldGet(_modelId, this);
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible) {
      var _classPrivateFieldGet21, _classPrivateFieldGet22;
      (_classPrivateFieldGet21 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet21 === void 0 || (_classPrivateFieldGet22 = _classPrivateFieldGet21.setVisible) === null || _classPrivateFieldGet22 === void 0 || _classPrivateFieldGet22.call(_classPrivateFieldGet21, visible);
    }
  }, {
    key: "setChartVisible",
    value: function setChartVisible(visible) {
      if (visible) {
        var _classPrivateFieldGet23, _classPrivateFieldGet24;
        (_classPrivateFieldGet23 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet23 === void 0 || (_classPrivateFieldGet24 = _classPrivateFieldGet23.openChart) === null || _classPrivateFieldGet24 === void 0 || _classPrivateFieldGet24.call(_classPrivateFieldGet23);
      } else {
        var _classPrivateFieldGet25, _classPrivateFieldGet26;
        (_classPrivateFieldGet25 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet25 === void 0 || (_classPrivateFieldGet26 = _classPrivateFieldGet25.closeChart) === null || _classPrivateFieldGet26 === void 0 || _classPrivateFieldGet26.call(_classPrivateFieldGet25);
      }
    }
  }, {
    key: "openManager",
    value: function openManager() {
      if (this.isEnable) {
        Entry.dispatchEvent('openAIUtilizeTrainManager');
      } else {
        console.log('Disabled learning for offline');
      }
    }
  }, {
    key: "predict",
    value: function () {
      var _predict = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(obj) {
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(_classPrivateFieldGet(_module, this) && _classPrivateFieldGet(_module, this).predict)) {
                _context4.next = 2;
                break;
              }
              _context4.next = 1;
              return _classPrivateFieldGet(_module, this).predict(obj);
            case 1:
              this.result = _context4.sent;
            case 2:
              return _context4.abrupt("return", []);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function predict(_x4) {
        return _predict.apply(this, arguments);
      }
      return predict;
    }()
  }, {
    key: "startPredict",
    value: function startPredict() {
      if (_classPrivateFieldGet(_module, this) && _classPrivateFieldGet(_module, this).startPredict) {
        _classPrivateFieldGet(_module, this).startPredict();
      }
    }
  }, {
    key: "stopPredict",
    value: function stopPredict() {
      if (_classPrivateFieldGet(_module, this) && _classPrivateFieldGet(_module, this).stopPredict) {
        _classPrivateFieldGet(_module, this).stopPredict();
      }
    }
  }, {
    key: "unbanBlocks",
    value: function unbanBlocks() {
      this.banBlocks();
      var blockMenu = getBlockMenu(_classPrivateFieldGet(_playground, this));
      if (blockMenu) {
        var _classPrivateFieldGet27, _classPrivateFieldGet28;
        (_classPrivateFieldGet27 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet27 === void 0 || (_classPrivateFieldGet28 = _classPrivateFieldGet27.unbanBlocks) === null || _classPrivateFieldGet28 === void 0 || _classPrivateFieldGet28.call(_classPrivateFieldGet27, blockMenu);
      }
    }
  }, {
    key: "banBlocks",
    value: function banBlocks() {
      var blockMenu = getBlockMenu(_classPrivateFieldGet(_playground, this));
      if (blockMenu) {
        banClasses.forEach(function (clazz) {
          blockMenu.banClass(clazz);
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _classPrivateFieldSet(_labels, this, []);
      _classPrivateFieldSet(_url, this, null);
      _classPrivateFieldSet(_type, this, null);
      this.isLoading = false;
      this.result = [];
      this.isLoaded = false;
      _classPrivateFieldSet(_recordTime, this, 2000);
      _classPrivateFieldSet(_tableData, this, null);
      if (_classPrivateFieldGet(_module, this)) {
        var _classPrivateFieldGet29, _classPrivateFieldGet30;
        (_classPrivateFieldGet29 = _classPrivateFieldGet(_module, this)) === null || _classPrivateFieldGet29 === void 0 || (_classPrivateFieldGet30 = _classPrivateFieldGet29.destroy) === null || _classPrivateFieldGet30 === void 0 || _classPrivateFieldGet30.call(_classPrivateFieldGet29);
        _classPrivateFieldSet(_module, this, null);
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      if (!this.isLoaded) {
        return;
      }
      return {
        labels: _classPrivateFieldGet(_labels, this),
        url: _classPrivateFieldGet(_url, this),
        type: _classPrivateFieldGet(_type, this),
        id: _classPrivateFieldGet(_modelId, this),
        _id: _classPrivateFieldGet(_oid, this),
        recordTime: _classPrivateFieldGet(_recordTime, this),
        trainParam: this.getTrainOption(),
        result: this.getTrainResult(),
        tableData: _classPrivateFieldGet(_tableData, this)
      };
    }
  }]);
}();
function getBlockMenu(playground) {
  var mainWorkspace = playground.mainWorkspace;
  if (!mainWorkspace) {
    return;
  }
  var blockMenu = _.result(mainWorkspace, 'blockMenu');
  if (!blockMenu) {
    return;
  }
  return blockMenu;
}
function createDataTable(classes, name) {
  if (!classes.length) {
    return;
  }
  try {
    var _data, _data2;
    var _classes = (0, _slicedToArray2["default"])(classes, 1),
      samples = _classes[0].samples;
    var _ref6 = samples || [],
      _ref7 = (0, _slicedToArray2["default"])(_ref6, 1),
      _ref7$ = _ref7[0],
      sample = _ref7$ === void 0 ? {} : _ref7$;
    var data = sample.data;
    data.id = data.id || data._id;
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }
    if (data && (_data = data) !== null && _data !== void 0 && _data.id && !_DataTable["default"].getSource((_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.id)) {
      _DataTable["default"].addSource(data, false);
    }
    return data;
  } catch (e) {
    console.log('set table error', e);
  }
}